import React from 'react';
import { format } from 'date-fns';
import LiveNotifier from './notifications/LiveNotifier';

const Header = ({ loading, error, game }) => {
  let statusText = 'LOADING';
  if (error) statusText = 'ERROR';
  else if (game?.status) statusText = game.status.abstractGameState.toUpperCase();

  const awayTeam = game?.teams?.away?.team;
  const homeTeam = game?.teams?.home?.team;

  const awayScore = game?.linescore?.teams?.away?.runs ?? game?.teams?.away?.score;
  const homeScore = game?.linescore?.teams?.home?.runs ?? game?.teams?.home?.score;

  const gameDateStr = game?.gameDate ? format(new Date(game.gameDate), 'EEE, MMM do, yyyy') : '--';
  
  const isLive = game?.status?.abstractGameState === 'Live';
  const isFinal = game?.status?.abstractGameState === 'Final';
  
  const isTopInning = game?.linescore?.isTopInning;
  const currentInning = game?.linescore?.currentInning;

  const showScore = (isLive || isFinal) && awayScore !== undefined && homeScore !== undefined;
  const awayWon = isFinal && Number(awayScore) > Number(homeScore);
  const homeWon = isFinal && Number(homeScore) > Number(awayScore);

  return (
    <div className="pb-4 mb-2 border-b-[3px] border-double border-[#8aa890] flex flex-col gap-4">
      <div className="flex justify-between items-center gap-3">
        <div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold tracking-widest uppercase text-[#d8ceb3] leading-tight">
            Boston Red Sox
          </h1>
          <h2 className="text-[10px] sm:text-sm tracking-[0.2em] uppercase text-[#a9c9b1] mt-1 font-medium">
            Green Monster Live Scoreboard
          </h2>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          <LiveNotifier game={game} />
          <div className="bg-[#e85555] border-2 border-white text-white font-bold text-sm sm:text-xl px-3 sm:px-8 py-1.5 sm:py-2 tracking-widest shadow-lg shrink-0">
            {statusText}
          </div>
        </div>
      </div>

      {game && (
        <div className="flex flex-col bg-[rgba(0,0,0,0.15)] border-y-2 border-[#658d71] shadow-inner overflow-hidden">
          <div className="bg-[rgba(216,206,179,0.1)] border-b border-[#658d71] py-2 px-4 flex items-center justify-between gap-2">
            <span className="text-[#d8ceb3] text-[10px] sm:text-xs font-bold tracking-[0.3em] uppercase">
              {gameDateStr}
            </span>
            {isLive && currentInning && (
              <div className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-[#e85555] animate-pulse" />
                <span className="text-[10px] text-[#e85555] font-black uppercase tracking-widest">
                  {isTopInning ? '▲' : '▼'} {currentInning}
                </span>
              </div>
            )}
            {isFinal && (
              <span className="text-[10px] text-[#658d71] font-bold uppercase tracking-widest">Final</span>
            )}
          </div>

          <div className="flex items-center justify-center gap-3 sm:gap-8 py-4 px-3">
            {/* Away Team */}
            <div className="flex flex-col items-center flex-1">
              <span className="text-[#a9c9b1] text-[9px] sm:text-xs font-bold tracking-widest uppercase mb-1">Away</span>
              <span className={`text-sm sm:text-xl md:text-2xl font-black uppercase tracking-tight text-center leading-tight ${awayWon ? 'text-[#d8ceb3]' : 'text-white'}`}>
                {awayTeam?.name || 'Away'}
              </span>
              {showScore && (
                <span className={`text-3xl sm:text-5xl md:text-6xl font-black tabular-nums mt-1 leading-none ${awayWon ? 'text-white' : isLive ? 'text-[#d8ceb3]' : 'text-[#a9c9b1]'}`}>
                  {awayScore}
                </span>
              )}
            </div>

            <div className="flex flex-col items-center shrink-0 gap-1">
              {showScore ? (
                <span className="text-[#658d71] text-xl sm:text-3xl font-black">–</span>
              ) : (
                <span className="text-[#d8ceb3] text-base sm:text-2xl font-black italic opacity-40">VS</span>
              )}
            </div>

            {/* Home Team */}
            <div className="flex flex-col items-center flex-1">
              <span className="text-[#a9c9b1] text-[9px] sm:text-xs font-bold tracking-widest uppercase mb-1">Home</span>
              <span className={`text-sm sm:text-xl md:text-2xl font-black uppercase tracking-tight text-center leading-tight ${homeWon ? 'text-[#d8ceb3]' : 'text-white'}`}>
                {homeTeam?.name || 'Home'}
              </span>
              {showScore && (
                <span className={`text-3xl sm:text-5xl md:text-6xl font-black tabular-nums mt-1 leading-none ${homeWon ? 'text-white' : isLive ? 'text-[#d8ceb3]' : 'text-[#a9c9b1]'}`}>
                  {homeScore}
                </span>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;